
import React, { Component } from 'react';
import { Sidebar } from '../common/Sidebar';
import { Dropdown } from 'semantic-ui-react';
import axios from 'axios';
import { AppContext } from '../../context/app/appContext';

class UpdateMerchant extends Component {
    constructor(props) {
        super(props)
        this.state = {
            providerName: '',
            merchantName: [],
            merchantNetworkId: [],
            showFields: false,
            filteredPerk: ''
        }
    }
    async componentDidMount() {
        const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
        let perksData = await axios.get(baseURL + '/perks/get-all')
        this.setState({ perksData: perksData.data.data })
        console.log("Perks Dtata = ", perksData)

    }
    renderUpdation(e) {
        this.setState({ providerName: e.target.value })
        this.setState({ showFields: true })
    }
    pushMerchantName0(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[0] = value
            this.setState(newState)
        }

    }
    pushMerchantName1(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[1] = value
            this.setState(newState)
        }

    }
    pushMerchantName2(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[2] = value
            this.setState(newState)
        }

    }
    pushMerchantName3(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[3] = value
            this.setState(newState)
        }

    }
    pushMerchantName4(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[4] = value
            this.setState(newState)
        }

    }
    pushMerchantName5(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[5] = value
            this.setState(newState)
        }

    }
    pushMerchantId0(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[0] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId1(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[1] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId2(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[2] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId3(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[3] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId4(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[4] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId5(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[5] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId6(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[6] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId7(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[7] = (value)
            this.setState(newState)
        }

    }

    findData = async () => {
        // const tempState = {...this.state}
        let tempData = this.state.perksData
        var token = localStorage.getItem('accessToken')
        tempData = tempData.filter(item => item.providerName === this.state.providerName)
        // tempState.filteredPerk = tempData[0]
        const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
        await axios.post(baseURL + '/perk/updatePerk', {
            id: tempData[0].id,
            merchantName: this.state.merchantName,
            merchantNetworkId: this.state.merchantNetworkId

        }, { headers: { Authorization: "Bearer " + token } })
        console.log("state =", this.state)
    }

    renderFields = () => {
        return (
            <div>
                <form className="ui form">
                    <div className="inline fields" >
                        <div className="field three wide">
                            <label>Name of the Merchant:</label>
                        </div>
                        <div className="field eight wide " style={{ display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                            <input type="text" required name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName0(e.target.value)} />
                            <input type="text" name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName1(e.target.value)} />
                            <input type="text" name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName2(e.target.value)} />
                            <input type="text" name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName3(e.target.value)} />
                            <input type="text" name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName4(e.target.value)} />
                            <input type="text" name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName5(e.target.value)} />

                        </div>
                    </div>
                    <div className="inline fields" >
                        <div className="field three wide">
                            <label>Merchant Network ID:</label>
                        </div>
                        <div className="field eight wide " style={{ display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                            <input type="text" required name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId0(e.target.value)} />
                            <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId1(e.target.value)} />
                            <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId2(e.target.value)} />
                            <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId3(e.target.value)} />
                            <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId4(e.target.value)} />
                            <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId5(e.target.value)} />
                            <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId6(e.target.value)} />
                            <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId7(e.target.value)} />

                        </div>

                    </div>

                </form>

                {/* <div className="perkName" style={{ display: "flex", flexDirection: "column", justifyContent: "space-around" }}> Name of the Merchant :
                    <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName0(e.target.value)}></input>
                    <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName1(e.target.value)}></input>
                    <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName2(e.target.value)}></input>
                    <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName3(e.target.value)}></input>
                    <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName4(e.target.value)}></input>
                    <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName5(e.target.value)}></input>
                </div>
                <div className="perkName" style={{ display: "flex", flexDirection: "column", justifyContent: "space-around" }}> Merchant Network ID :
                    <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId0(e.target.value)}></input>
                    <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId1(e.target.value)}></input>
                    <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId2(e.target.value)}></input>
                    <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId3(e.target.value)}></input>
                    <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId4(e.target.value)}></input>
                    <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId5(e.target.value)}></input>
                    <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId6(e.target.value)}></input>
                    <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId7(e.target.value)}></input>
                </div> */}
            </div>
        )
    }

    render() {
        return (
            <div>
                <form className="ui form">
                    <div className="inline fields">
                        <div className="field three wide">
                            <label>Name of the perk:</label>
                        </div>
                        <div className="field eight wide">
                            <input type="text" required name="perkName" placeholder="Enter the Perk Name" onChange={(e) => this.renderUpdation(e)} />
                        </div>
                    </div>
                    {this.state.showFields ? this.renderFields() : <div>Enter the exact provider name to start</div>}
                    <button onClick={() => this.findData()}>Done</button>

                </form>
                {/* <div className="perkName"> Name of the perk:
                    <input type="text" className="perkInput" name="perkName" onChange={(e) => this.renderUpdation(e)}></input>
                </div> */}
                {/* {this.state.showFields ? this.renderFields() : <div>Enter the exact provider name to start</div>} */}
                {/* <button className="ui button" type="submit" onClick={() => this.findData()}>Done</button> */}
            </div>
        );
    }
}

export default UpdateMerchant;